import { render } from "./gateway-attribute-item.vue?vue&type=template&id=13a3b538"
import script from "./gateway-attribute-item.vue?vue&type=script&lang=js"
export * from "./gateway-attribute-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__